import React from "react";
import { LOGO_URL, COLLEGE } from "../lib/data";

export default function Logo({ size = 44, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 min-w-0 ${className}`}>
      <div
        className="flex items-center justify-center rounded-md bg-black overflow-hidden shadow-sm ring-1 ring-black/10 shrink-0"
        style={{ width: size, height: size }}
      >
        <img
          src={LOGO_URL}
          alt="Cambridge College of Technology"
          className="w-full h-full object-contain"
        />
      </div>
      {showText && (
        <div className="leading-tight min-w-0 flex-1 overflow-hidden">
          <div className="font-display text-[16px] sm:text-[17px] font-semibold text-cct-blue tracking-tight truncate">
            {COLLEGE.shortName}
          </div>
          <div className="text-[9px] sm:text-[10px] tracking-[0.12em] uppercase text-gold font-semibold truncate">
            Cambridge College
          </div>
        </div>
      )}
    </div>
  );
}
